/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { bool } from 'prop-types';
import classNames from 'clsx';

import styles from './spinner.scss';

/**
 * This is the Spinner component class.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const Spinner = ({ small, medium, large }) => (
  <div
    className={classNames(styles.spinner, {
      [styles.small]: small,
      [styles.medium]: medium,
      [styles.large]: large,
    })}
  />
);

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Spinner.propTypes = {
  small: bool,
  medium: bool,
  large: bool,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
Spinner.defaultProps = {
  small: false,
  medium: false,
  large: false,
};

export default Spinner;
